import { Drawer, Box, IconButton, Toolbar, Typography, Divider } from "@mui/material";
import { Close } from "@mui/icons-material";
import { DrawerNavMenu } from "./DrawerNavMenu";
import type { NavItems } from "./navItems";
import { ThemeSwitch } from "./ThemeSwitch";
import { AuthUserMenu } from "src/infrastructure/auth";
import { useDrawer } from "src/utils/useDrawer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DRAWER_WIDTH = 307;

/**
 * Mobile navigation drawer (temporary overlay).
 *
 * Features:
 * - Modal overlay
 * - Auto-closes on route change
 * - Logo and app name at top
 * - Navigation menu items
 * - Theme toggle
 * - User profile at bottom
 */
export function DrawerMobile({ navItems }: { navItems: NavItems }) {
  const { isOpen, hide } = useDrawer();
  const location = useLocation();

  // Auto-close drawer when route changes
  useEffect(() => {
    hide();
  }, [location.pathname, hide]);

  return (
    <Drawer
      variant="temporary"
      open={isOpen}
      onClose={hide}
      ModalProps={{
        keepMounted: true, // Better mobile performance
      }}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: DRAWER_WIDTH,
        },
      }}
    >
      {/* Logo/Header with Close Button */}
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img src="/logo-insight.svg" alt="Insight Logo" style={{ height: 64, width: "auto" }} />
          <Typography variant="h6" noWrap component="div">
            Customer Portal
          </Typography>
        </Box>
        <IconButton onClick={hide} edge="end">
          <Close />
        </IconButton>
      </Toolbar>

      <Divider />

      {/* Navigation Menu */}
      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <DrawerNavMenu items={navItems} />
      </Box>

      <Divider />

      {/* Theme Switch */}
      <ThemeSwitch collapsed={false} />

      <Divider />

      <AuthUserMenu collapsed={false} />
    </Drawer>
  );
}
